import React from 'react'
import {
    Container,
    Divider,
    Flex,
    Grid,
    Text,
    Title,
    useMantineTheme,
} from '@mantine/core'
import { IconMail, IconMicroscope, IconPhone } from '@tabler/icons-react'
import PageLoader from 'components/UI/PageLoader/PageLoader'
import HeaderMain from 'components/UI/Headers/HeaderMain/HeaderMain'
import NavigationMain from 'components/UI/NavigationMain/NavigationMain'
import FooterMain from 'components/UI/FooterMain/FooterMain'
import HeaderPage from 'components/UI/Headers/HeaderPage/HeaderPage'
import BreadcrumbsMain from 'components/UI/Breadcrums/BreadcrumsMain/BreadcrumsMain'
import useScreen from 'hooks/useScreen'
import styles from './styles.module.scss'
const MyMonitor = () => {
    const theme = useMantineTheme()

    const { pageData } = useScreen()

    if (!pageData) {
        return <PageLoader />
    } else {
        const { data, posts } = pageData
        return (
            <div className={styles.layout}>
                <HeaderMain />
                <NavigationMain />
                <main>
                    <HeaderPage
                        title={data.title}
                        summary={data.summary}
                        theme='themeAlmond'
                    />
                    <BreadcrumbsMain />
                    <Flex sx={{ width: '100%' }}>
                        {posts.length === 0 ? (
                            <Container className={styles.container}>
                                <Text fz='2x'>
                                    Actualmente no existen monitoras
                                    relacionadas con su indicación terapéutica o
                                    medicamento.
                                </Text>
                            </Container>
                        ) : (
                            <Container className={styles.container}>
                                <Grid gutter='4x'>
                                    {posts.map((guide) => (
                                        <Grid.Col
                                            lg={3}
                                            md={4}
                                            sm={6}
                                            xs={12}
                                            key={guide._id}
                                        >
                                            <Title c='darkGrey.0' order={4}>
                                                {guide.data.name}
                                            </Title>

                                            <Title c='darkGrey.3' order={6}>
                                                {guide.data.title}
                                            </Title>

                                            <Divider
                                                mt='2xs'
                                                size='xs'
                                                sx={(theme) => ({
                                                    borderTopColor:
                                                        theme.colors.purple[0],
                                                })}
                                            />
                                            <Flex
                                                justify='flex-end'
                                                direction='column'
                                                align='flex-start'
                                                gap='.5rem'
                                                pt='.5rem'
                                            >
                                                <Flex
                                                    align='middle'
                                                    gap='.25rem'
                                                >
                                                    <IconMicroscope
                                                        size={theme.spacing.lg}
                                                        stroke={2}
                                                        color={
                                                            theme.colors
                                                                .purple[0]
                                                        }
                                                    />
                                                    <Text
                                                        fz='sm'
                                                        c='darkGrey.0'
                                                    >
                                                        {
                                                            guide.data
                                                                .professionalArea
                                                        }
                                                    </Text>
                                                </Flex>
                                                <Flex
                                                    align='middle'
                                                    gap='.25rem'
                                                >
                                                    <IconPhone
                                                        size={theme.spacing.lg}
                                                        stroke={2}
                                                        color={
                                                            theme.colors
                                                                .purple[0]
                                                        }
                                                    />
                                                    <Text
                                                        fz='sm'
                                                        c='darkGrey.0'
                                                    >
                                                        {
                                                            guide.data.contact
                                                                .mobile
                                                        }
                                                    </Text>
                                                </Flex>
                                                <Flex
                                                    align='middle'
                                                    gap='.25rem'
                                                >
                                                    <IconMail
                                                        size={theme.spacing.lg}
                                                        stroke={2}
                                                        color={
                                                            theme.colors
                                                                .purple[0]
                                                        }
                                                    />
                                                    <Text
                                                        fz='sm'
                                                        c='darkGrey.0'
                                                    >
                                                        {
                                                            guide.data.contact
                                                                .email
                                                        }
                                                    </Text>{' '}
                                                </Flex>
                                            </Flex>
                                            <Flex justify='flex-end'></Flex>
                                        </Grid.Col>
                                    ))}
                                </Grid>
                            </Container>
                        )}
                    </Flex>
                </main>
                <FooterMain />
            </div>
        )
    }
}

export default MyMonitor
